import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DownloadIcon, EyeIcon, GiftIcon, LayersIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const highlights = [{
  icon: LayersIcon,
  value: '6-in-1',
  label: 'Complete Instructor System'
}, {
  icon: BookOpenIcon,
  value: '150',
  label: 'Ready-to-Teach Barre Classes'
}, {
  icon: EyeIcon,
  value: '100%',
  label: 'Visual Core Teaching Material'
}, {
  icon: GiftIcon,
  value: '5',
  label: 'Professional Bonus Guides'
}, {
  icon: DownloadIcon,
  value: 'Immediate',
  label: 'Digital Access'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-background px-4 pb-16 pt-14 sm:pb-24 sm:pt-20" data-id="element-178" data-mp="nbomx02vuk1c">
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-179" data-mp="3d33d6tuq0lin">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-180" data-mp="380vxpuaomnbk">
          <p className="font-display text-2xl font-semibold text-foreground sm:text-3xl" data-id="element-181" data-mp="3o6kfvj9sie5n">
            <ProductName script data-id="element-182" data-mp="39b4gcyqfxq1v" />
          </p>
          <Ornament className="mt-4" data-id="element-183" data-mp="39cfm343g57vm" />
          <h1 className="mx-auto mt-6 max-w-4xl text-4xl font-semibold leading-[1.08] text-foreground sm:text-5xl lg:text-6xl" data-id="element-184" data-mp="3e8wkcr4d12mf">
            Solve Months of Barre Class Planning in Just{' '}
            <span className="italic text-primary" data-id="element-185" data-mp="358hmyte4fx2k">5 MINUTES</span>
          </h1>
          <p className="mx-auto mt-5 max-w-3xl text-sm font-semibold uppercase leading-6 tracking-[0.08em] text-primary-strong" data-id="element-186" data-mp="35akni7cwh8lj">
            Barre Instructor Ready: 6-Volume Instructor System + 150
            Ready-to-Teach Classes + 5 Professional Bonus Guides
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 w-full sm:mt-10" data-id="element-187" data-mp="2hlj9m4lat58v">
          <img src="https://cdn.magicpatterns.com/uploads/8g3VX7d8PrAPnzhitWuXRi/Diseno_sin_titulo_(67).png" alt="Barre Instructor Ready: 6-volume box set, Class Finder tablet and the 5 bonus guides" className="mx-auto w-full max-w-2xl drop-shadow-xl" data-id="element-188" data-mp="naa0aponrglg" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7 flex flex-col items-center" data-id="element-189" data-mp="1b0dte347zxy7">
          <p className="mx-auto max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg" data-id="element-190" data-mp="x1eehn6iexf8">
            The Complete <span className="font-semibold text-primary" data-id="element-191" data-mp="3ltgmzq8oqqoc">6-in-1</span>{' '}
            Visual Teaching System with 150 Ready-to-Teach Barre Classes,
            Progressive Sequences, Coaching Cues, Modifications, Corrections &
            Professional Instructor Tools.
          </p>
          <PriceTag className="mt-8" data-id="element-192" data-mp="21amwtbz2vwne" />
          <div className="mt-7" data-id="element-193" data-mp="21bpmjgknzt1q">
            <CheckoutButton data-id="element-194" data-mp="218tpdugn58ec">GET BARRE INSTRUCTOR READY NOW</CheckoutButton>
          </div>
          <p className="mt-4 text-xs font-medium text-muted-foreground" data-id="element-195" data-mp="268ofvwwi7vyv">
            Immediate Access · Complete Digital PDF Bundle
          </p>
          <ul className="mx-auto mt-10 grid w-full max-w-4xl grid-cols-2 gap-3 border-t border-accent/30 pt-8 sm:grid-cols-3 lg:grid-cols-5" data-id="element-196" data-mp="2g0bzxcqqeaqb">
            {highlights.map(({
            icon: Icon,
            value,
            label
          }) => <li key={label} className="flex flex-col items-center gap-2 rounded-xl border border-accent/40 bg-background px-3 py-4 text-xs font-semibold uppercase leading-5 tracking-[0.06em] text-foreground" data-id="element-197" data-mp="2p08tnsrz9zs8">
                <Icon size={20} strokeWidth={1.5} className="text-accent" aria-hidden="true" data-id="element-198" data-mp="uou2r8n8duaw" />
                <span className="font-display text-xl font-semibold normal-case tracking-normal text-primary" data-id="element-199" data-mp="49je886ectnp">
                  {value}
                </span>
                {label}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}